import moment from 'moment'
const validator = {
  validate (value) {
    let newdate = moment(value, 'DD/MM/YYYY', true)
    if (newdate.isValid()) {
      let datenow = moment()
      return newdate.isSameOrBefore(datenow, 'date')
    } else {
      return false
    }
  }
}
export default validator



// WEBPACK FOOTER //
// ./src/components/i18n/dateeqorpast.validator.js